import React, { useRef, useEffect } from 'react';
import { Box, Typography, Container } from '@mui/material';

const Hero = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      // Set playback rate to 0.5 (half speed) - adjust this value as needed
      // 0.5 = half speed, 0.75 = 75% speed, 1.0 = normal speed
      videoRef.current.playbackRate = 0.5;
    }
  }, []);

  return (
    <Box
      id="home"
      sx={{
        position: 'relative',
        width: '100%',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        backgroundColor: '#000000',
      }}
    >
      {/* Video Background */}
      <Box
        component="video"
        ref={videoRef}
        autoPlay
        loop
        muted
        playsInline
        type="video/mp4"
        src="/hero-video.mp4"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0,
          filter: 'grayscale(100%)',
        }}
      >
        Your browser does not support the video tag.
      </Box>

      {/* Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          zIndex: 1,
        }}
      />

      {/* Content */}
      <Container
        sx={{
          position: 'relative',
          zIndex: 2,
          textAlign: 'center',
          color: 'white',
          px: { xs: 3, sm: 4, md: 6 },
        }}
      >
        <Typography
          variant="h1"
          component="h1"
          sx={{
            mb: { xs: 2, md: 3 },
            fontWeight: 700,
            textShadow: '2px 2px 8px rgba(0,0,0,0.8)',
            color: 'white',
            fontSize: { xs: '2rem', sm: '2.5rem', md: '3.5rem' },
            lineHeight: { xs: 1.2, md: 1.2 },
          }}
        >
          Quality Work Made Simple
        </Typography>
        <Typography
          variant="h5"
          component="p"
          sx={{
            mb: { xs: 3, md: 4 },
            maxWidth: '800px',
            mx: 'auto',
            textShadow: '1px 1px 4px rgba(0,0,0,0.8)',
            color: 'white',
            lineHeight: 1.6,
            fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' },
            px: { xs: 2, md: 0 },
          }}
        >
          Precision turned parts delivered on time, every time. We make reliability
          the standard, not the exception.
        </Typography>
        <Typography
          variant="body1"
          sx={{
            maxWidth: '700px',
            mx: 'auto',
            textShadow: '1px 1px 4px rgba(0,0,0,0.8)',
            color: 'rgba(255,255,255,0.9)',
            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' },
            px: { xs: 2, md: 0 },
          }}
        >
          At JOCAST Machining, we deliver top-quality turned parts with a focus on
          rapid responses and collaborative solutions tailored to your needs.
        </Typography>
      </Container>
    </Box>
  );
};

export default Hero;
